import { CommunicationPreferenceModel } from '@common/models/CommunicationPreferenceModel';
import { Page } from '@customer/components/layout';
import { AppointmentsStore } from '@customer/stores';
import { AppointmentList, CommunicationPreference, WhatToExpect } from '@customer/views';
import { observer } from 'mobx-react';
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
export const AppointmentsContainer = observer(() => {
    const [store] = useState<AppointmentsStore>(new AppointmentsStore());
    const { verificationpublicid } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (verificationpublicid) {
            store.publicId = verificationpublicid;
            store.getAppointmentAndVisitData()
                .catch(() => {
                    navigate("/verification");
                });
        }
    }, [store, verificationpublicid, navigate]);

    const latestCommunicationPreference = useMemo(() => {
        return store.latestCommunicationPreference || new CommunicationPreferenceModel();
    }, [store.latestCommunicationPreference]);

    return (
        <>
            <Page>
                <Page.Content>
                    {
                        store.apptList
                            .map((lst, index) => (
                                <Row key={'apptLst_' + index}>
                                    <Col xs={12}>
                                        <h4 className="fw-bold">{lst.name}</h4>

                                        <p>{lst.description}</p>

                                        <AppointmentList store={store} apptList={lst} listName={`apptLst_${index}`} />

                                        {
                                            false && lst.canViewWhatToExpect &&
                                                <>
                                                    <WhatToExpect />
                                                </>
                                        }
                                    </Col>
                                </Row>
                            ))
                    }
                    {
                        store.apptList && store.apptList.length > 0 && store.apptList[0].showCommunicationPreference &&
                        <>
                            <CommunicationPreference store={store} preference={latestCommunicationPreference!} />
                        </>
                    }
                </Page.Content>
            </Page>
        </>
    )
});
